import { Message } from "element-ui";
export const myMessage = params => {
  if (window.plus) {
    plus.nativeUI.toast(
      `<span style="color:#fff;font-size:22px;">${params}</span>`,
      {
        verticalAlign: "center",
        type: "richtext",
        background: "rgba(0, 0, 0, .6)",
        duration: "long"
      }
    );
  } else {
    Message.error(params);
  }
};



// WEBPACK FOOTER //
// ./src/utils/message.js